import moment from "moment";
import {
  getDaysBetweenDates,
  getAllHoursInRange,
  getAllMinutesInRange,
} from "./moment-utils";

export const insertDaysDataPoints = <T extends { x: Date | string }>(
  items: T[],
  start: T,
  end: T,
  dateFormat: string,
  emptyDataPoint: T
): T[] => {
  const datesBetweenPeriod = getDaysBetweenDates(start.x, end.x, dateFormat);

  // datesBetweenPeriod && console.log("datesBetweenPeriod: ", datesBetweenPeriod);

  return datesBetweenPeriod.map((d) => {
    const dateDataPoint = items.find(
      (it) => moment(it.x).format(dateFormat) === d
    );

    // dateDataPoint && console.log("dateDataPoint: ", dateDataPoint);

    return dateDataPoint
      ? { ...dateDataPoint, x: d }
      : { ...emptyDataPoint, x: d };
  });
};

export const insertTodayDataPoints = <T extends { x: Date | string }>(
  items: T[],
  startDateTimeDataPoint: T,
  endTimeDataPoint: T,
  timeFormat: string,
  emptyDataPoint: T,
  nullDataPoint: T,
  fillToCurrentTimeOnly: boolean
): T[] => {
  // console.log("items in insertHoursDataPoints: ", items);

  const timesBetweenPeriod = getAllMinutesInRange(
    startDateTimeDataPoint.x,
    endTimeDataPoint.x,
    30,
    timeFormat
  );

  // method 1: fill only the elapsed time periods
  // let startTimePeriod = timesBetweenPeriod[0];
  // while(moment(startTimePeriod).isBefore(moment())){
  //   const timeDataPoint = items.find((it) => it.x === d);
  // }

  return timesBetweenPeriod.map((d) => {
    const timeDataPoint = items.find((it) => it.x === d);

    // timeDataPoint && console.log("timeDataPoint: ", timeDataPoint);

    return timeDataPoint
      ? { ...timeDataPoint, x: d }
      : { ...(fillToCurrentTimeOnly ? nullDataPoint : emptyDataPoint), x: d };
  });
};

export const mapToXY = <T, Tx, Ty>(
  items: T[],
  xGetter: (item: T) => Tx,
  yGetter: (item: T) => Ty
): { x: Tx; y: Ty }[] => {
  // console.log("items in mapToXY: ", items);

  return items.map((item) => ({
    x: xGetter(item),
    y: yGetter(item),
  }));
};
